<template>
<div>
  <FormInput label="Chat Id" :value="data.chat_id" hint="@channelusername or @groupusername or user_id" @update="data.chat_id=$event"></FormInput>
  <FormInput label="Message Id" :value="data.message_id" hint="Id of the message to edit" @update="data.message_id=$event"></FormInput>
  <Message :text="data.text" @updateMessage="data.text=$event"></Message>
  <ReplyMarkupInline :reply_markup="data.reply_markup" :actions="actions" @changeReplyMarkup="data.reply_markup=$event"></ReplyMarkupInline>

</div>
</template>


<script>
import FormInput from '@/components/tasks/fields/FormInput.vue'
import Message from '@/components/tasks/fields/Message.vue'
import ReplyMarkupInline from '@/components/tasks/fields/ReplyMarkupInline.vue'




export default {
  name: 'EditMessageText',
  components: {
    FormInput,
    Message,
    ReplyMarkupInline
  },
  props: {
    data: Object,
    actions: Object
  },
}
</script>
